export default __webpack_public_path__ + "static/media/V230_RoHS.1c60a7b6.pdf";